import { render, staticRenderFns } from "./AbkObservedSearchResult.vue?vue&type=template&id=85c6524c&scoped=true&"
import script from "./AbkObservedSearchResult.vue?vue&type=script&lang=js&"
export * from "./AbkObservedSearchResult.vue?vue&type=script&lang=js&"
import style0 from "./AbkObservedSearchResult.vue?vue&type=style&index=0&id=85c6524c&scoped=true&lang=scss&"
import style1 from "./AbkObservedSearchResult.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85c6524c",
  null
  
)

export default component.exports